import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface User {
  id: string
  title?: string
  firstName: string
  lastName: string
  email: string
  company?: string
  companyStreet?: string
  companyCity?: string
  companyCountry?: string
  phone?: string
  street: string
  city: string
  country: string
  isAdmin: boolean
  canReleaseFilings?: boolean
  twoFactorEnabled?: boolean
  twoFactorMethod?: "app" | "email"
  // The rules, as the server states them for this account
  twoFactorMandatory?: boolean
  twoFactorAppRequired?: boolean
}

interface AuthState {
  isAuthenticated: boolean
  user: User | null
  token: string | null
  refreshToken: string | null
}

const savedToken = localStorage.getItem("token")
const savedRefreshToken = localStorage.getItem("refreshToken")
const savedUser = localStorage.getItem("user")

const initialState: AuthState = {
  isAuthenticated: !!savedToken,
  user: savedUser ? JSON.parse(savedUser) : null,
  token: savedToken,
  refreshToken: savedRefreshToken
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (
      state,
      action: PayloadAction<{
        token: string
        refreshToken: string
        user: User
      }>
    ) => {
      state.isAuthenticated = true
      state.token = action.payload.token
      state.refreshToken = action.payload.refreshToken
      state.user = action.payload.user

      localStorage.setItem("token", action.payload.token)
      localStorage.setItem("refreshToken", action.payload.refreshToken)
      localStorage.setItem("user", JSON.stringify(action.payload.user))
    },

    setNewTokens: (
      state,
      action: PayloadAction<{ token: string; refreshToken: string }>
    ) => {
      state.token = action.payload.token
      state.refreshToken = action.payload.refreshToken

      localStorage.setItem("token", action.payload.token)
      localStorage.setItem("refreshToken", action.payload.refreshToken)
    },

    updateUser: (state, action: PayloadAction<Partial<User>>) => {
      if (!state.user) return

      state.user = { ...state.user, ...action.payload }
      localStorage.setItem("user", JSON.stringify(state.user))
    },

    logout: (state) => {
      state.isAuthenticated = false
      state.user = null
      state.token = null
      state.refreshToken = null

      localStorage.removeItem("token")
      localStorage.removeItem("refreshToken")
      localStorage.removeItem("user")
    },
  },
})

export const { loginSuccess, logout, setNewTokens, updateUser } =
  authSlice.actions
export default authSlice.reducer
